// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2qbCT","list":"styles_list__oQkxh"};